import { TFunction } from "i18next";

export enum ROLES {
  Admin = "ADMIN",
  Issuer = "ISSUER",
  Verifier = "VERIFIER",
  SuperAdmin = "SUPER_ADMIN",
  Holder = "HOLDER",
}
export const USER_ROLES = {
  Admin: ROLES.Admin,
  Issuer: ROLES.Issuer,
  Verifier: ROLES.Verifier,
  SuperAdmin: ROLES.SuperAdmin,
};

export enum BILLING_METHOD {
  CREDIT_CARD = "CREDIT_CARD",
  BANK = "BANK",
}

export enum DESIGN_TYPE {
  CERTIFICATE = "CERTIFICATE",
  BADGE = "BADGE",
}

export enum ASSET_TYPE {
  BACKGROUND = "BACKGROUND",
  LOGO = "LOGO",
  ICON = "ICON",
  OTHER = "OTHER",
}

export enum ORIENTATION {
  PORTRAIT = "PORTRAIT",
  LANDSCAPE = "LANDSCAPE",
  SQUARE = "SQUARE",
  UNKNOWN = "UNKNOWN",
}

export enum NOTIFICATIONSTATUS {
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum TEMPLATE_TYPE {
  VERIFIABLE_CREDENTIAL = "VERIFIABLE_CREDENTIAL",
  VERIFIABLE_PRESENTATION_REQUEST = "VERIFIABLE_PRESENTATION_REQUEST",
}

export enum VPREQUEST_TYPE {
  QR_CODE = "QR_CODE",
  HOLDER = "HOLDER",
}

export enum VP_RESULT {
  PARTIAL_VERIFIED = "PARTIAL_VERIFIED",
  VERIFIED = "VERIFIED",
  PARTIAL_ACCEPTED = "PARTIAL_ACCEPTED",
  ACCEPTED = "ACCEPTED",
  NOT_FOUND = "NOT_FOUND",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  INVALID = "INVALID",
}

export enum VP_STATUS {
  REQUEST_SENT = "REQUEST_SENT",
  DOCUMENT_RECEIVED = "DOCUMENT_RECEIVED",
  REQUEST_REJECTED = "REQUEST_REJECTED",
}

export enum PARAM_REDUCER_TYPE {
  SET_LIMIT = "SET_LIMIT",
  SET_ORDER = "SET_ORDER",
  SET_PAGE = "SET_PAGE",
  SET_DATE_RANGE = "SET_DATE_RANGE",
  SET_SEARCH = "SET_SEARCH",
  SET_ORDER_BY = "SET_ORDER_BY",
  SET_DEPARTMENT = "SET_DEPARTMENT",
  SET_CREDENTIAL_TYPE = "SET_CREDENTIAL_TYPE",
}

export const getVpResultDropdown = (t: TFunction) => [
  { label: t("all"), value: "" },
  { label: t("accepted"), value: VP_RESULT.ACCEPTED },
  { label: t("Partial Accepted"), value: VP_RESULT.PARTIAL_ACCEPTED },
  { label: t("Verified"), value: VP_RESULT.VERIFIED },
  { label: t("Partial Verified"), value: VP_RESULT.PARTIAL_VERIFIED },
  { label: t("Pending"), value: VP_RESULT.PENDING },
  { label: t("Rejected"), value: VP_RESULT.REJECTED },
  { label: t("Invalid"), value: VP_RESULT.INVALID },
  { label: t("Not Found"), value: VP_RESULT.NOT_FOUND },
];

export const getVpStatusDropdown = (t: TFunction) => [
  { label: t("all"), value: "" },
  { label: t("RequestSent"), value: VP_STATUS.REQUEST_SENT },
  { label: t("DocumentReceived"), value: VP_STATUS.DOCUMENT_RECEIVED },
  { label: t("RequestRejected"), value: VP_STATUS.REQUEST_REJECTED },
];